import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { entidadesService } from '../../services';
import { Entidade } from '../../types/pessoas';

const formatEndereco = (endereco: any): string => {
  if (!endereco || typeof endereco !== 'object') return '-';
  const parts = [
    endereco.logradouro,
    endereco.bairro,
    endereco.cidade_nome,
    endereco.uf_sigla,
    endereco.cep,
  ].filter(Boolean);
  return parts.length ? parts.join(', ') : `Endereço #${endereco.id ?? ''}`;
};

const columns: ResourceColumn<Entidade>[] = [
  { header: 'Razão social', accessor: 'razao_social' },
  { header: 'Documento', accessor: 'documento' },
  { header: 'Tipo', accessor: 'tipo_pessoa' },
  { header: 'E-mail', accessor: 'email' },
  { header: 'Telefone', accessor: 'telefone' },
  {
    header: 'Tipos',
    render: (item) => item.tipos_info?.map((t) => t.descricao).join(', ') || '—',
  },
  {
    header: 'Endereço',
    render: (item) => formatEndereco((item as any).endereco_info ?? (item as any).endereco),
  },
];

export const EntidadesListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Entidades"
      description="Cadastro base de clientes, fornecedores e colaboradores."
      columns={columns}
      service={entidadesService}
      createPath="/admin/pessoas/entidades/novo"
      onEdit={(item) =>
        (item as { id?: number }).id &&
        navigate('/admin/pessoas/entidades/editar', { state: { record: item } })
      }
      onDelete={(item) =>
        (item as { id?: number }).id ? entidadesService.remove((item as any).id) : Promise.resolve()
      }
    />
  );
};
